
const BaseModel = require('utils/baseModel');
class CategoryTreeNode extends BaseModel {
    constructor(data) {
        super();
        if (data) {
            this.cateCreator = data.cateCreator;
            this.cateUser = data.cateUser;
            this.cateContent = data.cateContent;
            let temp = JSON.stringify(data.cateIcon);
            this.cateIcon = JSON.parse(temp);
            this.cateLabel = data.cateLabel;
            this.cateRoot = data.cateRoot;
            this.cateParent = data.cateParent;
            this.cateId = data.cateId;
            this.cateTitle = data.cateTitle;
            this.cateIndex = data.cateIndex;
            this.cateLevel = data.cateLevel;
            this.children = [];
            this.originalChildren = [];
            this.getIcon();
            if (!(this.cateIcon instanceof Array)) this.cateIcon = Array.of(this.cateIcon);
        }
        else {
            this.cateIcon = [];
        }
    }

    getIcon() {
        if (this.cateIcon instanceof Array) {
            for (let index in this.cateIcon) {
                let ci = this.cateIcon[index];
                if (ci && !ci.includes(process.env.OSS_PREFIX)) {
                    this.cateIcon[index] = process.env.OSS_PREFIX + ci;
                }
                if(!ci){
                    this.cateIcon.splice(index,1);
                }
            }
        }
    }

    get checked() {
        return this._checked;
    }

    set checked(value) {
        this._checked = value;
    }

    get singleCheck() {
        return this._singleCheck;
    }

    set singleCheck(value) {
        this._singleCheck = value;
    }

    static needCheck(type) {
        return {
            cateTitle: {title: '品类标题', length: 32},
            cateRoot: {title: '根品类'},
            cateParent: {title: '父品类'},
            cateIndex: {title: '品类索引'},
            // cateIcon: {title: '品类图标', length: 1024}

        }
    }


    checkModel() {
        if (this.cateIcon) {
            this.cateIcon = this.cateIcon[0];
            if (this.cateIcon && this.cateIcon.indexOf(process.env.OSS_PREFIX) >= 0) {
                this.cateIcon = this.cateIcon.slice(process.env.OSS_PREFIX.length);
            }
        }
    }

    get originalChildren() {
        return this._originalChildren;
    }

    set originalChildren(value) {
        this._originalChildren = value;
    }

    get cateRoot() {
        return this._cateRoot;
    }

    set cateRoot(value) {
        this._cateRoot = value;
    }


    get cateId() {
        return this._cateId;
    }

    set cateId(value) {
        this._cateId = value;
    }

    get cateLevel() {
        return this._cateLevel;
    }

    set cateLevel(value) {
        this._cateLevel = value;
    }

    get cateParent() {
        return this._cateParent;
    }

    set cateParent(value) {
        this._cateParent = value;
    }

    get children() {
        return this._children;
    }

    set children(value) {
        this._children = value;
    }

    get cateCreator() {
        return this._cateCreator;
    }

    set cateCreator(value) {
        this._cateCreator = value;
    }

    get cateUser() {
        return this._cateUser;
    }

    set cateUser(value) {
        this._cateUser = value;
    }

    get cateContent() {
        return this._cateContent;
    }

    set cateContent(value) {
        this._cateContent = value;
    }

    get cateIcon() {
        return this._cateIcon;
    }

    set cateIcon(value) {
        this._cateIcon = value;
    }

    get cateLabel() {
        return this._cateLabel;
    }

    set cateLabel(value) {
        this._cateLabel = value;
    }

    get cateTitle() {
        return this._cateTitle;
    }

    set cateTitle(value) {
        this._cateTitle = value;
    }

    get cateIndex() {
        return this._cateIndex;
    }

    set cateIndex(value) {
        this._cateIndex = value;
    }


}


module.exports = CategoryTreeNode;


// WEBPACK FOOTER //
// ./src/bo/categoryManage/categoryTreeNode.js